/*
 * File: getPrescriptionUploadLink
 * Project: meki
 * File Created: Friday, 25th September 2020 12:47:01 pm
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Monday, 1st February 2021 5:49:52 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { ResolverParams } from '@queries/queries.interfaces';
import { AwsUploadData } from '@utils/upload';

export const getPrescriptionUploadLink = (name: string) => gql`
  query ${name}($params: GetPrescriptionUploadLinkParams) {
    getPrescriptionUploadLink(params: $params)
  }
`;

export interface GetPrescriptionUploadLinkResponse {
  getPrescriptionUploadLink: AwsUploadData;
}
export type GetPrescriptionUploadLinkParams = ResolverParams<{
  format: string;
}>;
